import { createRouter, createWebHistory } from "vue-router";
import ProfileLayout from "@/layouts/ProfileLayout.vue";
import ClearLayout from "@/layouts/ClearLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";

import store from "@/store";
import userStore from "@/store/user";
import mainStore from "@/store/main.store";
import { i18n } from "@/boot/i18n";

const routes = [
  {
    path: "/",
    component: MainLayout,
    children: [
      {
        name: "Lending",
        path: "",
        component: () => import("@/views/Index.vue"),
      },
      {
        path: "/contacts",
        component: () => import("@/views/Contacts.vue"),
      },
      {
        path: "/for-business/rdo",
        component: () =>
          import("@/views/index/for-business/IndexForBusinessRDO.vue"),
      },
      {
        path: "/for-business/cursir",
        component: () =>
          import("@/views/index/for-business/IndexForBusinessCursir.vue"),
      },
      // {
      //   path: "/for-business/rc-media",
      //   component: () =>
      //     import("@/views/index/for-business/IndexForBusinessRCMedia.vue"),
      // },
      // {
      //   path: "/for-business/gr",
      //   component: () =>
      //     import("@/views/index/for-business/IndexForBusinessGR.vue"),
      // },
      {
        path: "login",
        redirect: "/account/login",
      },

      {
        path: "new-password",
        redirect: "/account/new-password",
      },

      {
        path: "email-check",
        redirect: "/account/registration",
      },

      {
        path: "account/email-check",
        redirect: "/account/registration",
      },

      {
        path: "register-code",
        redirect: "/account/registration",
      },
    ],
  },
  {
    path: "/oauth/login",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/auth/WikiAuth"),
        meta: {
          show_countries: false,
          show_translates: false,
          show_back_button: false,
          is_internal_back_route: false,
          back_button_route: {
            text: "RC Group Wiki",
            name: "",
            route: import.meta.env.VITE_APP_FRONT_RC_WIKI_URL,
          },
        },
      },
    ],
  },
  {
    path: "/account",
    component: AuthLayout,
    children: [
      // авторизация
      {
        path: "",
        redirect: "/account/login",
      },
      {
        name: "Login",
        path: "login",
        component: () => import("@/views/auth/Login.vue"),
      },
      {
        name: "ResetPassword",
        path: "reset-password",
        component: () => import("@/views/ResetPassword/ResetPassword.vue"),
      },
      {
        name: "NewPassword",
        path: "new-password",
        component: () => import("@/views/ResetPassword/NewPassword.vue"),
      },
      {
        name: "NewManagerPassword",
        path: "new-manager-password",
        component: () =>
          import("@/modules/managers/components/NewManagerPassword.vue"),
      },
      {
        name: "Registration",
        path: "registration",
        components: {
          default: () => import("@/views/auth/Registration.vue"),
          navigation: () =>
            import("@/components/registration/SidebarNavigation.vue"),
        },
      },
    ],
  },
  {
    path: "/payment-decision",
    component: ProfileLayout,
    redirect: { name: "PaymentMethodsConnection" },
    children: [
      {
        name: "PaymentMethods",
        path: "payment-methods",
        redirect: { name: "PaymentMethodsConnection" },
        component: () => import("@/views/cabinet/PaymentMethods.vue"),

        children: [
          {
            name: "PaymentMethodsConnection",
            path: "create",
            component: () =>
              import(
                "@/modules/payment-methods/pages/ConnectionView/PaymentMethodsConnection.vue"
              ),
          },
          {
            name: "PaymentMethodsHistory",
            path: "history",
            component: () =>
              import(
                "@/modules/payment-methods/pages/HistoryView/PaymentMethodsHistory.vue"
              ),
          },
        ],
      },
    ],
    meta: ["payment_info"],
  },
  {
    path: "/cabinet",
    component: ProfileLayout,
    children: [
      {
        path: "",
        redirect: "/",
      },
      {
        name: "Balance",
        path: "balance",
        component: () => import("@/views/cabinet/Balance.vue"),
        meta: {
          permissions: ["balance"],
        },
      },
      {
        name: "Analytics",
        path: "analytics",
        component: () => import("@/views/cabinet/analytics/Analytics.vue"),
        meta: {
          permissions: ["analytics"],
        },
      },
      {
        name: "Bally",
        path: "bally",
        component: () => import("@/views/cabinet/loyalty/Cashback.vue"),
        meta: {
          permissions: ["cashback"],
        },
      },
      {
        name: "Promotions",
        path: "promotions",
        component: () => import("@/views/cabinet/loyalty/Promotions"),
        meta: {
          permissions: ["promotion"],
        },
      },
      {
        name: "History",
        path: "history",
        component: () => import("@/views/portfolio/Operations.vue"),
        meta: {
          permissions: ["operation"],
        },
      },
      {
        name: "Clients",
        path: "clients",
        component: () => import("@/views/cabinet/clients/Clients.vue"),
        meta: {
          permissions: ["client"],
        },
      },
      {
        name: "Reviews",
        path: "reviews",
        component: () => import("@/views/cabinet/clients/Reviews.vue"),
        meta: {
          permissions: ["review"],
        },
      },
      {
        name: "Notifications",
        path: "push-notifications",
        component: () =>
          import("@/views/cabinet/loyalty/PushNotifications.vue"),
        meta: {
          permissions: ["push-notifications"],
        },
      },
      {
        name: "Spread",
        path: "spread",
        component: () => import("@/views/cabinet/spread/Spread.vue"),
        meta: {
          permissions: ["spread"],
        },
      },
      {
        name: "Wallet",
        path: "wallet",
        component: () => import("@/views/cabinet/wallet/Wallet.vue"),
        meta: {
          permissions: ["wallet-pass"],
        },
      },
      {
        path: "managers",
        component: ClearLayout,
        children: [
          {
            path: "",
            name: "Managers",
            component: () => import("@/views/cabinet/ManagersView.vue"),
          },
        ],
        meta: {
          permissions: ["manager"],
        },
      },
      {
        path: "employee",
        component: ClearLayout,
        children: [
          {
            path: "",
            name: "Employee",
            component: () => import("@/views/cabinet/employee/Employees.vue"),
          },
          {
            path: "score/:id",
            name: "EmployeeAbout",
            component: () => import("@/views/cabinet/employee/EmployeeScore"),
            props: true,
          },
        ],
        meta: {
          permissions: ["employee"],
        },
      },
      {
        name: "Points",
        path: "points",
        component: () => import("@/views/cabinet/Points.vue"),
        meta: {
          permissions: ["points"],
        },
      },
      {
        path: "entities",
        component: ClearLayout,
        children: [
          {
            path: "",
            name: "Entities",
            component: () => import("@/views/cabinet/Entities.vue"),
          },
        ],
        meta: {
          permissions: ["legal-entity"],
        },
      },
      {
        path: "trading-point",
        component: ClearLayout,
        children: [
          {
            path: "",
            name: "TradingPoint",
            component: () =>
              import(
                "@/modules/trading-points/TradingPointsPage/TradingPointsPage.vue"
              ),
          },
          {
            path: ":id",
            component: ClearLayout,
            children: [
              {
                path: "history",
                name: "TradingPointHistory",
                component: () =>
                  import(
                    "@/views/cabinet/trading-points/TradingPointsChecksHistory.vue"
                  ),
                props: true,
              },
            ],
          },
        ],
        meta: {
          permissions: ["trading-point"],
        },
      },
      {
        name: "Documents",
        path: "documents",
        component: () => import("@/views/cabinet/Documents.vue"),
        meta: {
          permissions: ["document"],
        },
      },
      {
        path: "acts",
        component: ClearLayout,
        children: [
          {
            path: "",
            name: "Acts",
            component: () => import("@/views/portfolio/ActsAndAccounts.vue"),
          },
        ],
        meta: {
          permissions: ["act-and-receipt"],
        },
      },
      {
        name: "Tariff",
        path: "tariff",
        component: () => import("@/views/cabinet/Tariffs.vue"),
        meta: {
          permissions: ["tariff"],
        },
      },
      {
        name: "PromotionServices",
        path: "promotion-services",
        component: () => import("@/views/promotions/Promotions.vue"),
        redirect: { name: "ServicesList" },

        children: [
          {
            name: "ServicesList",
            path: "catalog",
            component: () =>
              import("@/modules/promotions/pages/ServicesList.vue"),
            props: (route) => ({ query: route.query.q }),
          },
          {
            name: "OrdersHistory",
            path: "orders-history",
            component: () =>
              import("@/modules/promotions/pages/OrdersHistory.vue"),
          },
        ],
      },
      {
        name: "PreOrders",
        path: "pre-orders",
        component: () => import("@/views/cabinet/PreOrders.vue"),
      },
      {
        name: "Counterparties",
        path: "counterparties",
        component: () => import("@/views/cabinet/Counterparties.vue"),
        meta: {
          permissions: ["check-counterparties"],
        },
      },
      {
        name: "Emenu",
        path: "e-menu",
        component: () => import("@/views/cabinet/e-menu/EMenu.vue"),
        redirect: { name: "Products" },
        children: [
          {
            name: "Products",
            path: "products",
            component: () => import("@/views/cabinet/e-menu/EMenu.vue"),
          },
          {
            name: "Categories",
            path: "categories",
            component: () => import("@/views/cabinet/e-menu/EMenu.vue"),
          },
        ],
        meta: {
          permissions: ["e-menu"],
        },
      },
      {
        name: "GiftCard",
        path: "gift-card",
        component: () => import("@/views/cabinet/gift-card/GiftCard.vue"),
        meta: {
          permissions: ["gift-card"],
        },
        redirect: { name: "GiftInformation" },
        children: [
          {
            name: "GiftInformation",
            path: "information",
            component: () =>
              import("@/views/cabinet/gift-card/GiftInformation.vue"),
          },
          {
            name: "GiftIssuedCards",
            path: "issued-cards",
            component: () =>
              import("@/views/cabinet/gift-card/GiftIssuedCards.vue"),
          },
        ],
      },
      {
        name: "DocumentLaboratory",
        path: "document-laboratory",
        component: () => import("@/views/cabinet/DocumentLaboratory.vue"),
        beforeEnter(_, from, next) {
          if (userStore.state.profile.country_code !== "ru") {
            store.dispatch("createNotification", {
              type: "error",
              status: i18n.global.t("sys.error"),
              message: "Нет доступа",
            });
            return next(from.path);
          }
          next();
        },
      },
      // {
      //   path: "terminals-MSPOS",
      //   component: ClearLayout,
      //   children: [
      //     {
      //       path: "",
      //       name: "MSPOS",
      //       component: () =>
      //         import("@/views/cabinet/processing/TerminalsMSPOS.vue"),
      //     },
      //   ],
      //   meta: {
      //     permissions: ["terminals"],
      //   },
      // },
      {
        path: "telegram-notification",
        component: () => import("@/views/cabinet/TgNotifications.vue"),
        name: "TgNotifications",
        meta: {
          permissions: ["telegram-notification"],
        },
      },
      {
        name: "FAQ",
        path: "FAQ",
        component: () => import("@/views/cabinet/FAQ.vue"),
      },
      {
        name: "PWAView",
        path: "download",
        component: () => import("@/views/cabinet/PWAView.vue"),
      },
    ],
  },
  {
    path: "/update-docs",
    component: ClearLayout,
    children: [
      {
        path: "",
        name: "UpdateDocs",
        component: () => import("@/views/UpdateDocs.vue"),
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    component: () => import("@/views/NotFoundPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach(async (to, from, next) => {
  if (mainStore.state.windowInnerWidth < 1280) {
    setTimeout(() => {
      store.commit("main/SET_IS_SHOW_SIDEBAR", false);
    }, 300);
  }

  if (to.meta.auth) {
    localStorage.setItem("isCollapsedSidebar", false);
    if (!localStorage.getItem("access_token")) {
      return next();
    } else {
      if (userStore.state.permissions.length === 0) {
        await store.dispatch("user/getProfileInformation");
      }

      const firstPermission = userStore.state.permissions.permissions[0];
      const routes = {
        balance: "/cabinet/balance",
        analytics: "/cabinet/analytics",
        "legal-entity": "/cabinet/entities",
        "trading-point": "/cabinet/trading-point",
        employee: "/cabinet/employee",
        document: "/cabinet/documents",
        business: "/cabinet/business",
        tariff: "/cabinet/tariff",
        operation: "/cabinet/history",
        "act-and-receipt": "/cabinet/acts",
        manager: "/cabinet/managers",
        cashback: "/cabinet/bally",
        spread: "/cabinet/spread",
        client: "/cabinet/clients",
        "wallet-pass": "/cabinet/wallet",
        review: "/cabinet/reviews",
        "trading-point-promotion": "/cabinet/promotion-services",
        orders: "/cabinet/pre-orders",
      };

      const nextRoute = routes[firstPermission] || "/cabinet/faq";
      return next(nextRoute);
    }
  }

  if (!to.meta.permissions) {
    return next();
  }

  if (userStore.state.permissions.length === 0) {
    await store.dispatch("user/getProfileInformation");
  }

  const profile = userStore.state.profile;

  if (!profile.personal_data_accepted_at && profile.country_code === "ru") {
    return next({ name: "UpdateDocs" });
  }

  const isOwner = profile.is_owner;
  const userPermissions = userStore.state.permissions;

  if (isOwner) {
    const tradingPointPath = "/cabinet/trading-point";
    if (profile.country_code === "ru" && to.path === tradingPointPath) {
      const hasPermission = userPermissions.includes("trading-point");
      if (!hasPermission) {
        const descr = "noPermissions";
        const mes = !Object.keys(i18n.global.tm("sys")).includes(descr)
          ? descr
          : i18n.global.t(`sys.${descr}`);

        store.dispatch("createNotification", {
          type: "error",
          status: i18n.global.t("sys.error"),
          message: mes,
        });
      }

      return next(hasPermission ? undefined : "/cabinet/balance");
    } else {
      return next();
    }
  } else {
    const hasPermission = to.meta.permissions.some((item) =>
      userPermissions.includes(item)
    );

    if (!hasPermission) {
      const descr = "noPermissions";
      const mes = !Object.keys(i18n.global.tm("sys")).includes(descr)
        ? descr
        : i18n.global.t(`sys.${descr}`);

      store.dispatch("createNotification", {
        type: "error",
        status: i18n.global.t("sys.error"),
        message: mes,
      });
    }
    return next(hasPermission ? undefined : from.path);
  }
});

export default router;
